import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { Button, FModal, LoadingIndicator } from '@components';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import error from '@assets/icons/error.svg';
import { StepsTBSimulacao } from './Steps';
import { TermosTBSimulacao } from './Terms';
import { Modal } from './components/Modal';

import { PercentualRecebimentoRendaService } from '../../../common/services/percentual-recebimento-renda';
import { CALCULADORA_EXAURIMENTO } from '../../../common/utils/paths';

const service = new PercentualRecebimentoRendaService();

export const CalculadoraExaurimentoPage = () => {
  const navigate = useNavigate();
  const { matricula, plano } = useSelector((state) => state.user.data);
  const dadosPessoais = useSelector((state) => state.user.dadosPessoais);

  const [dadosIniciais, setDadosIniciais] = useState({});
  const [viewTerms, setViewTerms] = useState(true);
  const [infoModalIsOpen, setInfoModalIsOpen] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalTableData, setModalTableData] = useState({});
  const [msgErro, setMsgErro] = useState('');
  const [loading, setLoading] = useState(true);
  const { aporte: showAporte, parcela_adicional: showParcelaAdicional } =
    useSelector((state) => state.configs.telasDisponiveis.data);

  const obterDadosIniciais = useCallback(async () => {
    const saldo = await service.getSaldoRemanescenteParticipante(
      matricula,
      plano
    );
    const beneficio = await service.getValorBeneficioParticipante(
      matricula,
      plano
    );

    const percentualMax = await service.getLimitePercentualCotasMensal(
      matricula,
      plano
    );

    const percentualAtual = await service.getRecebimentoSaldoContas(
      matricula,
      plano
    );

    const data = {
      matricula,
      plano,
      nome: dadosPessoais.nome,
      dataNascimento: dadosPessoais.dataNascimento,
      idade: dadosPessoais.idade,
      beneficioAtual: beneficio,
      reserva: Number(saldo?.replace(',', '.')),
      percentualMax,
      percentualAtual,
    };
    setDadosIniciais(data);
    setLoading(false);
  }, [dadosPessoais, matricula, plano]);

  useEffect(() => {
    obterDadosIniciais();
  }, [obterDadosIniciais]);

  return (
    <>
      <Helmet>Forluz - Simulador de evolução de saldo</Helmet>
      <h1 className="page-title mb-3">
        <strong>Simulador de evolução de saldo</strong>
      </h1>

      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      {!loading ? (
        <div>
          {viewTerms ? (
            <TermosTBSimulacao setViewTerms={setViewTerms} />
          ) : (
            <StepsTBSimulacao
              setInfoModalIsOpen={setInfoModalIsOpen}
              setModalIsOpen={setModalIsOpen}
              setModalTableData={setModalTableData}
              data={dadosIniciais}
              setMsgErro={setMsgErro}
              visibleAporte={showAporte}
              visibleParcelaAdicional={showParcelaAdicional}
            />
          )}
        </div>
      ) : (
        <LoadingIndicator />
      )}

      {infoModalIsOpen && (
        <Modal
          modalIsOpen={infoModalIsOpen}
          setModalIsOpen={setInfoModalIsOpen}
          data={modalTableData}
        />
      )}
      {modalIsOpen && (
        <FModal
          isOpen={modalIsOpen}
          close={false}
          onClose={() => setModalIsOpen(false)}
        >
          <img className="mb-4" src={error} alt="Error Icon" />
          <h1 className="ts-20 fw-bold mb-1">{msgErro}</h1>
          <Button
            className="mt-32"
            onClick={() => {
              setModalIsOpen(false);
              navigate(CALCULADORA_EXAURIMENTO);
            }}
          >
            Ok
          </Button>
        </FModal>
      )}
    </>
  );
};
